import { render } from "./AuthorPage.vue?vue&type=template&id=c9cf430a"
import script from "./AuthorPage.vue?vue&type=script&lang=ts"
export * from "./AuthorPage.vue?vue&type=script&lang=ts"
script.render = render

export default script